import { useEffect, useRef, useState } from 'react';

import { useCollapse, useMediaQuery } from '@crehana/react-hooks';

import { useCourseDetailTranslation } from '@/views/OrgCourseDetail/hooks';

const CourseDescription: React.FC<{
  courseDescription: string;
}> = ({ courseDescription }) => {
  const { matches: isSm } = useMediaQuery('sm');
  const { t } = useCourseDetailTranslation();
  const descriptionRef = useRef<HTMLParagraphElement>(null);
  const [hasHiddenContent, setHasHiddenContent] = useState(false);
  const { getToggleProps, getCollapseProps, isOpen } = useCollapse({
    collapsedHeight: isSm ? 176 : 66,
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentionally managed
  useEffect(() => {
    if (descriptionRef.current) {
      setHasHiddenContent(
        descriptionRef.current.scrollHeight > (isSm ? 176 : 66),
      );
    }
  }, [courseDescription, isSm]);

  return (
    <section className="tw-relative tw-pt-2">
      {courseDescription && (
        <div {...getCollapseProps()} className="tw-mb-1.2">
          <p
            ref={descriptionRef}
            className="tw-font-body4"
            dangerouslySetInnerHTML={{
              __html: courseDescription,
            }}
          />
        </div>
      )}

      {hasHiddenContent && (
        <button
          type="button"
          className="tw-font-subtitle5 tw-text-primary-light-500 hover:tw-text-primary-light-600 tw-transition-colors tw-duration-200"
          {...getToggleProps()}
        >
          {t(isOpen ? 'SHOW_LESS' : 'SHOW_MORE')}
        </button>
      )}
    </section>
  );
};

export default CourseDescription;
